import type { RequestOptions } from '@inflearn/datasource-rest';
import { type UseMutationOptions, useMutation } from '@tanstack/react-query';

import type { EmptyResponse } from '../../../../../../resources/@types/courseSchema';
import { uccFetcher } from '../../../../../../resources/Fetcher';

export function useClientApiVouchersIdFreeDeleteMutationForB2B(
  { voucherId }: { voucherId: string | number },
  options?: Parameters<typeof useClientApiV1VouchersIdFreeDeleteForB2BMutation>[0]['options'],
) {
  return useClientApiV1VouchersIdFreeDeleteForB2BMutation({
    url: `/v1/group-user/vouchers/${voucherId}/cancel`,
    options,
  });
}

export function useClientApiV1VouchersIdFreeDeleteForB2BMutation<TContext>({
  url,
  options,
  requestOptions,
}: {
  url: string;
  options?: UseMutationOptions<EmptyResponse, unknown, unknown, TContext>;
  requestOptions?: RequestOptions;
}) {
  const result = useMutation<EmptyResponse, unknown, unknown, TContext>(
    (variables) => uccFetcher.delete(url, variables, requestOptions),
    options,
  );

  return { ...result, data: result.data?.data };
}
